<template>
  <div>
    <titulo-usuario @cadastrar="openModal" />
    <div class="row">
      <div class="col-12 col-md-4">
        <input-text
          ref="nome"
          v-model="filtro.nome"
          :label="$t(`USUARIOS.NOME`)"
        />
      </div>
      <div class="col-12 col-md-3">
        <input-select-search
          ref="perfilId"
          v-model="filtro.perfilId"
          :label="$t(`USUARIOS.PERFIS_ASSOCIADOS`)"
          :options="opcoes.perfis"
        />
      </div>
      <b-col cols="12" md="auto">
        <b-button
          class="w-100 botao-acao-filtro"
          variant="primary"
          @click="getUsuarios"
        >
          {{ $t('GERAL.FILTRAR') }}
        </b-button>
      </b-col>
      <b-col cols="12" md="auto">
        <b-button
          class="w-100 botao-acao-filtro mt-3"
          variant="secondary"
          @click="limparFiltro"
        >
          {{ $t('GERAL.LIMPAR') }}
        </b-button>
      </b-col>
    </div>
    <tabela
      :usuarios="usuarios"
      @adicionar-perfis="openModal"
      @editar="openModal"
      @excluir="excluir"
      @alterar-ordenacao="novaOrdenacao"
    />

    <paginacao
      v-model="paginacao"
      :total="paginacao.total"
      @input="getUsuarios"
    />

    <modal-usuario
      :exibir="modais.usuario"
      :item="modais.usuarioDados"
      @atualizar="getUsuarios"
      @fechar="closeModal"
    />
    <modal-adicionar-perfis
      :exibir="modais.adicionarPerfis"
      :item="modais.adicionarPerfisDados"
      @atualizar="getUsuarios"
      @fechar="closeModal"
      @perfil-atualizado="getUsuarios"
    />
  </div>
</template>

<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import Permisoes from '@/components/mixins/permissoes';
import mensagem from '@/common/utils/mensagem';
import modais from '@/common/utils/modais';

// Services:
import UsuarioService from '@/common/services/usuario/usuario.service';
import PerfisService from '@/common/services/perfis/perfis.service';

// Components:
import Tabela from './components/Tabela';
import ModalAdicionarPerfis from './components/modais/Perfis';
import ModalUsuario from './components/modais/Usuario';
import Paginacao from '@/components/paginacao/Paginacao';
import TituloUsuario from './components/TituloUsuario.vue';
import { InputSelectSearch, InputText } from '@/components/inputs';

export default {
  mixins: [Permisoes],
  components: {
    TituloUsuario,
    Tabela,
    Paginacao,
    ModalAdicionarPerfis,
    ModalUsuario,
    InputSelectSearch,
    InputText,
  },
  data() {
    return {
      filtro: {
        nome: null,
        perfilId: null,
      },
      opcoes: {
        perfis: [],
      },
      usuarios: [],
      modais: {
        adicionarPerfis: false,
        adicionarPerfisDados: {},
        usuario: false,
        usuarioDados: {},
      },
      paginacao: {
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
      },
      campoOrdenado: null,
      ordem: false
    };
  },
  mounted() {
    this.getUsuarios();
    this.getPerfis();
  },
  methods: {
    limparFiltro() {
      this.filtro = {
        nome: null,
        perfilId: null,
      };
    },
    getPerfis() {
      this.$store.dispatch(START_LOADING);
      PerfisService.listarTodos()
        .then(({ data }) => {
          data = data.map((row) => ({
            ...row,
            text: row.descricao,
            value: row.id,
          }));
          this.opcoes.perfis = data;
        })
        .catch((err) => {
          mensagem.erro(this.$t('GERAL.ERRO'), err.response.data.errors);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getUsuarios() {
      let param = {
        NumeroDaPagina: this.paginacao.numeroDaPagina,
        TamanhoDaPagina: this.paginacao.tamanhoDaPagina,
        CampoOrdenado :this.campoOrdenado, 
        OrdenacaoAscendente:this.ordem,
        Nome: this.filtro.nome, 
        PerfilId: this.filtro.perfilId
      }
      this.$store.dispatch(START_LOADING);
      UsuarioService.listar(param)
        .then(({ data }) => {
          this.usuarios = data.itens;
          this.paginacao.total = data.paginacao.totalDeElementos;
        })
        .catch((err) => {
          mensagem.erro(this.$t('GERAL.ERRO'), err.response.data.errors);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    excluir(item) {
      mensagem
        .confirmacao(
          null,
          this.$t('USUARIOS.CONFIRMAR_EXCLUIR').formatUnicorn({
            nome: item.nome,
          })
        )
        .then(async (result) => {
          if (result.value) {
            this.$store.dispatch(START_LOADING);
            UsuarioService.excluir(item.id)
              .then(() => {
                mensagem.sucesso(
                  this.$t('GERAL.SUCESSO'),
                  this.$t('USUARIOS.MENSAGEM_EXCLUIDO')
                );
                this.getUsuarios();
              })
              .catch((err) => {
                mensagem.erro(this.$t('GERAL.ERRO'), err);
              })
              .finally(() => {
                this.$store.dispatch(STOP_LOADING);
              });
          }
        });
    },
    openModal(key, item) {
      return modais.abrirModal(this, key, item);
    },
    closeModal(key) {
      return modais.fecharModal(this, key);
    },
    novaOrdenacao(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = ordem;
      this.getUsuarios(); 
    },
  },
};
</script>
